import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom"; // Importez Link et useNavigate

export default function Lien() {
    const { t } = useTranslation("footer");
    const navigate = useNavigate(); // Initialize useNavigate

    const handleClick = (e, path) => {
        e.preventDefault(); // Empêche le rechargement de la page
        navigate(path); // Utilisez navigate pour changer de route
        window.scrollTo({ top: 0, behavior: "smooth" }); // Défilement en douceur
    };

    return (
        <div className="Lien">
            <div className="politique">
                <Link
                    to="/conditionsUtilisation"
                    onClick={(e) => handleClick(e, "/conditionsUtilisation")}
                    className="itempolitique"
                >
                    {t("footer.Lien.condition")}
                </Link>
                <Link
                    to="/politiqueConfidentialite"
                    onClick={(e) => handleClick(e, "/politiqueConfidentialite")}
                    className="itempolitique"
                >
                    {t("footer.Lien.politique")}
                </Link>
                <a
                    href="https://ulrichlontsi2024.web.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="copirite"
                >
                    {t("footer.Lien.copi")}
                </a>
            </div>
        </div>
    );
}
